define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/html",
	"csi/xml",
	"./AttributeAction",
	"./StringComment"
], function(declare,lang,html,xml,AttributeAction,StringComment) {

	return declare(StringComment, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML; if action exists, then add content
			// necessary to invoke edit mode (toHtmlDynamic); return false if no content
			var	value = this._getValue(ctx, h);
			if (value) {
				var comments = this._parseJson(value);

				if (comments instanceof Array) {
					if (comments.length > 0) {
						// comments array is already sorted by _parseJson call.
						value = this._commentToString(comments[comments.length -1]);
					} else {
						value = "";
					}
				}

				html.multiLineText(refNode, value);
				return true;
			}

			return false;
		},

		toTooltip: function(/*Context*/ctx, /*Heading*/h, /*Tooltip*/tooltip) {
			// summary: generate tooltip for comments
			var	value = this._getValue(ctx, h);
			if (value) {
				tooltip.addAction(this._mixinTooltipAction(lang.mixin(new AttributeAction(), {
					m_id: "ShowCommentsHistory",
					m_right: xml.RIGHT_WRITE,
					classController: "csi.heading.StringCommentPopupController"
				}), h));				
			}
		}
	});
});